function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.8571 24.519V27.882C12.8571 28.2336 13.1553 28.5185 13.5 28.5185C13.855 28.5185 14.1429 28.2231 14.1429 27.882V24.519C14.8919 24.2521 15.4286 23.5318 15.4286 22.6852C15.4286 21.6113 14.5651 20.7407 13.5 20.7407C12.4349 20.7407 11.5714 21.6113 11.5714 22.6852C11.5714 23.5318 12.1081 24.2521 12.8571 24.519ZM3.85714 14.2593V9.72123C3.85714 4.35128 8.1744 0 13.5 0C18.8148 0 23.1429 4.35234 23.1429 9.72123V14.2593C25.276 14.2654 27 16.0097 27 18.1604V31.0988C27 33.2673 25.268 35 23.1316 35H3.86844C1.73004 35 0 33.2534 0 31.0988V18.1604C0 15.9958 1.72586 14.2654 3.85714 14.2593ZM7.71429 14.2593V9.72333C7.71429 6.49347 10.3046 3.88889 13.5 3.88889C16.6889 3.88889 19.2857 6.50106 19.2857 9.72333V14.2593H7.71429Z",
  fill: "#C4C4C4"
});

var SvgActivityLockIcon = function SvgActivityLockIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgActivityLockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activity-lock-icon.dc4dcf6a.svg";
export { ForwardRef as ReactComponent };